import {
    SET_CURRENT_USER, LOG_IN_FAILURE, LOG_OUT, AUTHENTICATE, SET_USER, UPDATE_PROFILE,
    SET_PERMISSIONS
} from './../actions/ActionTypes';
import InitialState from './InitialState';
import {isEmpty} from 'lodash';
import {
    clearToken, getToken, setUser, setToken, getUser, setLocation, 
    setCurrentLocation, getCurrentLocation, setPermission
} from '../utils/TokenManager';


const AuthReducer = (state = InitialState.auth, action) => {
    switch (action.type) {
        case SET_CURRENT_USER: {
            const loginState = Object.assign({}, state);
            loginState.isAuthenticated = !isEmpty(action.authData);
            const user = Object.assign({}, action.authData);
            const token= action.authData.token.split(".");

            const agencyLocation= action.authData.agency_location;
            const LocationList = action.authData.agency_location_list;
            loginState.user = {
                ...user,
                role: JSON.parse(atob(token[1])),
                agency_location_list: [...LocationList],
                agency_location: agencyLocation,
                permissions: []
            };
            setPermission(user.permissions);
            setLocation(LocationList);
            setToken(action.authData.token);
            // setPermission(action.authData.permission);
            setUser(loginState.user);
            if (!parseInt(getCurrentLocation())) {
                setCurrentLocation(user.agency_location);
            }
            
            return loginState;
        }

        case SET_USER: {
            const loginState = Object.assign({}, state);
            loginState.isAuthenticated = !isEmpty(action.authData);
            return loginState;
        }

        case LOG_IN_FAILURE:
            return state;

        case LOG_OUT: {
            clearToken().then(() => {
                window.location.reload(true);
                window.location.replace('/login');
            }).catch(err => {
                console.log(err);
            });
        }

        case AUTHENTICATE: {
            let user = getUser();
            if (user && typeof getToken() && !isEmpty(getToken())) {
                const loginState = Object.assign({}, state);
                loginState.isAuthenticated = true;
                loginState.user = user;
                loginState.profile = user;
                return loginState;
            }
            return state;
        }

        case UPDATE_PROFILE: {
            const authState = Object.assign({}, state);
            authState.profile = action.profileData;
            return authState;
        }

        case SET_PERMISSIONS: {
            setPermission(action.permissions);
            const authState = {...state, permissions: [...action.permissions]};
            return authState;
        }

        default:
            return state;
    }
};
export default AuthReducer;



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js